/**
 * レスポンシブ判定
 *
 * @params { string }
 * @export
 * @example mq("pc") => PCの場合true、SPの場合false
 * @returns { boolean }
 */
export const mq = (device) =>
  window.matchMedia('(min-width:768px)').matches ? device === 'pc' : device === 'sp';

/**
 *
 * レスポンシブ判定により、ビューポートの設定を変更
 * @export
 * @example setViewport()
 * @returns { void }
 */
export function setViewport() {
  var viewport = document.querySelector('meta[name=viewport]');
  var width = window.innerWidth;
  if (width <= 768) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
  } else {
    viewport.setAttribute('content', 'width=1440, initial-scale=1.0');
  }
}
